import { v4 as uuidv4 } from "uuid";
import { useNotifications } from "@/stores/notifications.ts";

/**
 * Time to display the notification in milliseconds
 */
type TTL = number;

export enum Status {
  SUCCESS = 0,
  FAILED = 1,
}

interface Props {
  title: string;
  status: Status;
  message?: string;
  ttl?: TTL;
}

export default class Notification {
  id: string;
  title: string;
  message?: string;
  status: Status;
  ttl?: TTL;
  private timeout?: ReturnType<typeof setTimeout>;

  constructor(props: Props) {
    this.id = uuidv4();
    this.title = props.title;
    this.message = props.message;
    this.status = props.status;
    this.ttl = props.ttl;

    if (this.ttl !== undefined) {
      const notifications = useNotifications();

      this.timeout = setTimeout(() => notifications.pop(this), this.ttl);
    }
  }

  // Dropping a notification has to stop its timer too, or dismissing it by hand leaves a callback
  // armed that keeps firing against an entry that is no longer on the stack.
  dismiss(): void {
    clearTimeout(this.timeout);
  }
}
